export default __webpack_public_path__ + "static/media/Logo.f9e1b904.png";